import React from "react";
import Alert from "view/components/Alert";
import {Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {generatePath, Link} from "react-router-dom";
import {SHOW_SETTINGS_PATH} from "view/routes";
import {useCurrentShowId} from "hooks";
import {grey} from "@material-ui/core/colors";

const TermPopupWarning = ({isBuildersEmpty}: {isBuildersEmpty: boolean}) => {
  const classes = useStyles();

  const showId = useCurrentShowId();

  const renderMessage = () => {
    if (isBuildersEmpty && showId) {
      return (
        <>
          There is no Build Type in the Show. <br />
          Create first one in the{" "}
          <Link
            to={generatePath(SHOW_SETTINGS_PATH, {showId})}
            className={classes.link}
          >
            Show Settings
          </Link>
        </>
      );
    }
    return <> At least one Build Type should be selected to enable a pop-up</>;
  };
  return (
    <Alert severity="info">
      <Typography className={classes.info}>{renderMessage()}</Typography>
    </Alert>
  );
};

const useStyles = makeStyles(() => ({
  info: {
    fontSize: "16px",
    color: grey[800],
  },
  link: {
    color: "inherit",
  },
}));

export default TermPopupWarning;
